module.exports = __webpack_public_path__ + "img/rhombus.541d8ba5.svg";